
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import {
  SpacingBarCssProperty,
  SpacingBarDescription,
  SpacingBarDescriptionV,
  SpacingBarLocation,
  SpacingBarLocationV,
  SpacingBarProperty
} from "@/types/elements";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";
import NotificationLogger from "@/lib/notifications/notifications";
import { iotsErrorsToCustomErrorType } from "@/util/io-ts-errors-to-_error";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { ElementStudioContext } from "@/components/ElementStudio/ElementStudioTabsAndPanels.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: { NiceButton, DropdownInput }
})
export default class ElementStudioSpacingBar extends Vue {
  @Prop()
  value!: SpacingBarDescription;

  newSpaceBar = this.value || {};

  @Inject("context") readonly context!: ElementStudioContext;

  get pathsToAllControls() {
    return this.context.getPathsToAllControls();
  }

  // merge location and property so that the user selects only one. They're tied together anyway and reduces errors
  get propertiesLocationsKeyPair() {
    const locations = SpacingBarLocationV.types.map(type => type.value);
    const cssProperties = SpacingBarCssProperty.types.map(type => type.value);

    return cssProperties.reduce(
      (acc, property, key) => ({ ...acc, [property]: locations[key] }),
      {}
    ) as Record<SpacingBarProperty, SpacingBarLocation>;
  }

  get cssProperties() {
    return Object.keys(this.propertiesLocationsKeyPair);
  }

  updateLocationAndProperty(newProperty: SpacingBarProperty) {
    this.newSpaceBar.cssProperty = newProperty;

    this.newSpaceBar.location = this.propertiesLocationsKeyPair[newProperty];
  }

  saveNewSpaceBar() {
    pipe(
      SpacingBarDescriptionV.decode(this.newSpaceBar),
      fold(
        e => {
          NotificationLogger.log.message(
            `Error saving new space bar, please fill out all fields`
          );

          iotsErrorsToCustomErrorType(e);
        },
        () => {
          this.$emit("input", this.newSpaceBar);
        }
      )
    );
  }
}
